import { api } from "../api/acquire";

interface OAuthStateParams {
  state: string;
  client_id: string;
  redirect_uri: string;
}

const useOAuth = () => {
  const storeOAuthState = async (params: OAuthStateParams) => {
    const apiClientId = process.env.NEXT_PUBLIC_COTRIBUTE_CLIENT_ID;

    return api.post("/auth/oauth/state", params, {
      headers: apiClientId
        ? {
            "X-Cotribute-Client-Id": apiClientId,
          }
        : {},
    });
  };

  const exchangeOAuthCode = async (
    params: {
      code: string;
      state: string;
      redirect_uri: string;
      client_id: string;
    },
    endpoint: string
  ) => {
    const apiClientId = process.env.NEXT_PUBLIC_COTRIBUTE_CLIENT_ID;

    return api.post(endpoint, params, {
      headers: apiClientId
        ? {
            "X-Cotribute-Client-Id": apiClientId,
          }
        : {},
    });
  };

  return {
    storeOAuthState,
    exchangeOAuthCode,
  };
};

export default useOAuth;
